import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  FORBIDDEN,
  HOME,
  PUBLIC_ROUTES_BEFORE_VOL_LOGIN,
  RESOURCES,
} from "_constants/PageRoutes";
import { useAuthContextUser } from "../context/AuthContext";
import AuthenticatedLayout from "../layout/AuthenticatedLayout";
import DashboardPage from "../pages/Dashboard/DashboardPage";
import Home from "../pages/Static/Home";
import {
  ApprovedProductsAllRouteToComponent,
  CertificationWorkflowRouteToComponent,
  CompanyContactsRouteToComponent,
  DafAcquirerVmidRouteToComponent,
  DafUploadRouteToComponent,
  DafVmidRouteToComponent,
  ExternalUserRouteToComponent,
  StorePurchaseRouteToComponent,
  SubscriptionManagerRouteToComponent,
  UserSettingEmailRouteToComponent,
  UserSettingRouteToComponent,
} from "../_constants/AuthenticatedRouteToComponent";
import ResourcePage from "pages/Static/ResourcePage";

const AuthUserRoute = (props) => {
  const user = useAuthContextUser();
  const isExternalUser = user && user.isExternalUser;
  const is3DSStoreViewable =
    user && user.navigation && user.navigation.storeMenu;
  const isSubscriptionManager = user && user.isSubscriptionManager;
  const isDafVmidViewable =
    user && user.navigation && user.navigation.dafVmidMenu;
  const isDafUploadViewable =
    user && user.navigation && user.navigation.dafUploadMenu;
  const isDafAcquirerVmidViewable =
    user && user.navigation && user.navigation.dafAcquirerVmidMenu;
  const isEmailNotificationSettingViewable =
    user && user.navigation && user.navigation.settingsMenuEmailNotification;
  const isApprovedProductAllViewable =
    user && user.navigation && user.navigation.approvedProductsStaffMenu;
  const isCompanyContactsViewable = user && user.navigation && user.navigation.companyContacts;
  const isDashboardViewable = user && user.navigation && user.navigation.dashboardMenu;
  const isCertificationWorkflowMenuViewable = user && user.navigation && user.navigation.certificationWorkflowMenu;

  return (
    <AuthenticatedLayout>
      <Switch>
        <Route exact path={HOME}>
          {isDashboardViewable && <DashboardPage />}
          {!isDashboardViewable && <Home />}
        </Route>
        <Route
          exact path={RESOURCES}>
            <ResourcePage/>
        </Route>
        {PUBLIC_ROUTES_BEFORE_VOL_LOGIN &&
          PUBLIC_ROUTES_BEFORE_VOL_LOGIN.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.redirect}
              component={route.component}
            ></Route>
          ))}
        {isExternalUser &&
          ExternalUserRouteToComponent &&
          ExternalUserRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
        {isSubscriptionManager &&
          SubscriptionManagerRouteToComponent &&
          SubscriptionManagerRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
        {is3DSStoreViewable &&
          StorePurchaseRouteToComponent &&
          StorePurchaseRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
          {isCertificationWorkflowMenuViewable &&
          CertificationWorkflowRouteToComponent &&
          CertificationWorkflowRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
         {isDafUploadViewable &&
          DafUploadRouteToComponent &&
          DafUploadRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))} 
        {isDafVmidViewable &&
          DafVmidRouteToComponent &&
          DafVmidRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))} 
         {isDafAcquirerVmidViewable &&
          DafAcquirerVmidRouteToComponent &&
          DafAcquirerVmidRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))} 
        {UserSettingRouteToComponent &&
          UserSettingRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
        {isEmailNotificationSettingViewable &&
          UserSettingEmailRouteToComponent &&
          UserSettingEmailRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
        {isApprovedProductAllViewable &&
          ApprovedProductsAllRouteToComponent &&
          ApprovedProductsAllRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
        {isCompanyContactsViewable &&
          CompanyContactsRouteToComponent &&
          CompanyContactsRouteToComponent.map((route, key) => (
            <Route
              key={key}
              exact
              path={route.path}
              component={route.component}
            ></Route>
          ))}
        <Redirect to={FORBIDDEN} />
      </Switch>
    </AuthenticatedLayout>
  );
};

export default AuthUserRoute;
